import { render, staticRenderFns } from "./FacilityEditTabParameters.vue?vue&type=template&id=547af110&"
import script from "./FacilityEditTabParameters.vue?vue&type=script&lang=js&"
export * from "./FacilityEditTabParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports